import React from "react";

export const MidTitle = (props) => {
  return <h5  style={{fontWeight:"600",textTransform: "uppercase",color:"#424242",fontSize:"14px" }} className={`${props.className} m-0`}>{props.text}</h5>;
};
